import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { makeApiRequest } from '../common'
import arcmIcons from '../Icons'
import { Select, Space } from 'antd'
import Modal from '../components/core/Modal'

const ArchivedOrder = () => {
  const [orders, setOrders] = useState([])
  const [activeView, setActiveView] = useState('archived_orders')
  const [isPro, setIsPro] = useState('')
  const [tableLoading, setTableLoading] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [bulkAction, setBulkAction] = useState('') // Track bulk action
  const [currentPage, setCurrentPage] = useState(1)
  const [totaOrderNumber, setTotaOrderNumber] = useState(0)
  const [modalLoading, setmodalLoading] = useState(false)
  const [isOpenUnarchiveModal, setIsOpenUnarchiveModal] = useState(false)
  const [modalTile, setmodalTile] = useState('Unarchiving Order')
  const [modaDesc, setmodaDesc] = useState('')
  const ordersPerPage = 10

  // New states for search
  const [searchQuery, setSearchQuery] = useState('')
  const [searchStatus, setSearchStatus] = useState('')
  const [isSearching, setIsSearching] = useState(false)

  // Calculate pagination details
  const totalPages = Math.ceil(parseInt(totaOrderNumber) / ordersPerPage)
  const startIndex = (currentPage - 1) * ordersPerPage

  // Toggle select all orders
  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)
    setOrders(orders.map(order => ({ ...order, is_selected: newSelectAll })))
  }

  // Toggle select individual order
  const handleSelectOrder = id => {
    const updatedOrders = orders.map(order =>
      order.id === id ? { ...order, is_selected: !order.is_selected } : order
    )
    setOrders(updatedOrders)
    setSelectAll(updatedOrders.every(order => order.isSelected)) // If all orders are selected
  }

  // New function to handle search
  const handleSearch = async () => {
    setTableLoading(true)
    setIsSearching(true)
    setCurrentPage(1) // Reset to first page when searching

    try {
      const response = await makeApiRequest('search-orders', 'POST', {
        search: searchQuery,
        status: searchStatus,
        ordersPerPage,
        startIndex: 0 // Start from first page
      })

      if (response.success) {
        setOrders(response.data.orders)
        setTotaOrderNumber(response.data.total_order)
      } else {
        setOrders([])
        setTotaOrderNumber(0)
      }
    } catch (error) {
      console.error('Search failed:', error)
      setOrders([])
      setTotaOrderNumber(0)
    }

    setTableLoading(false)
  }

  // Clear search function
  const clearSearch = () => {
    setSearchQuery('')
    setSearchStatus('')
    setIsSearching(false)
    setCurrentPage(1)
  }

  // Get Selected Order
  const getSelectedOrder = () => {
    const selectedOrder = orders.filter(order => order.is_selected)
    return selectedOrder
  }

  // delete order from remote database
  const deleteOrder = async orders => {
    let orderIds = []
    orders.map(order => {
      orderIds.push(order.id)
    })
    setmodalTile('Unarchiving order complete')
    setmodaDesc('Deleting Unarchived order from RDS')
    const deleteRemoteOrders = await makeApiRequest('delete-unarchived-orders', 'POST', orderIds);
    if (deleteRemoteOrders.success) {
      setmodalTile('Successfulley Order Unarchived')
      setmodaDesc('')
      setmodalLoading(false)
      if (searchStatus) {
        handleSearch()
      } else {
        getArchivedOrder()
      }
    }
  }

  // Handle unarchiving single order
  const unarchiveOrder = async orders => {
    setmodalLoading(true)
    handleUnarchiveModal()
    const unarchiveOrders = await makeApiRequest('unarchive-orders', 'POST', orders);
    if (unarchiveOrders.success) {
      deleteOrder(orders)
    } else {
      setmodalTile('Modal Loading Failed')
    }
  }

  // single order unarchive
  const singelOrderUnarchive = orderId => {
    const order = orders.filter(order => order.id === orderId)
    unarchiveOrder(order)
  }

  // Handle bulk actions (unarchive selected orders)
  const handleBulkAction = () => {
    if (bulkAction === 'unarchive') {
      const selectedOrders = getSelectedOrder()
      if (selectedOrders.length == 0) {
        alert('please select order')
        return
      }
      unarchiveOrder(selectedOrders)
    } else {
      alert('No bulk action selected')
    }
  }

  // get archived order form server
  const getArchivedOrder = async () => {
    setTableLoading(true)
    if (isSearching) {
      // If we're in search mode, use search endpoint
      try {
        const response = await makeApiRequest('search-orders', 'POST', {
          search: searchQuery,
          status: searchStatus,
          ordersPerPage,
          startIndex
        });

        if (response.success) {
          setOrders(response.data.orders)
          setTotaOrderNumber(response.data.total_order)
        } else {
          if (response.data?.dbConnectionError) {
            setDbConnected(false)
          }
          setOrders([])
          setTotaOrderNumber(0)
        }
      } catch (error) {
        console.error('Search failed:', error)
        setOrders([])
        setTotaOrderNumber(0)
      }
    } else {
      // Normal fetch if not searching
      const archivedData = await makeApiRequest('get-archived-order', 'POST', {
        ordersPerPage,
        startIndex
      });
      console.log(archivedData)
      if (archivedData.success) {
        const { orders, total_order } = archivedData.data
        setOrders(orders)
        setTotaOrderNumber(total_order)
      } else {
        if (archivedData.data?.dbConnectionError) {
          setDbConnected(false)
        }
        setOrders([])
      }
    }
    setTableLoading(false)
  }

  // Handle pagination
  const handlePageChange = page => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  // hadlde close open unarchiving modal
  const handleUnarchiveModal = () => {
    setIsOpenUnarchiveModal(!isOpenUnarchiveModal)
  }

  // Custom function to determine if a menu is active
  const isActive = path => location.pathname === path

  // Redirect to ArchiveMaster pro page
  const redirectProPage = () => {
    const url = 'https://archivemaster.pro/'
    window.open(url, '_blank')
  }

  useEffect(() => {
    getArchivedOrder()
  }, [currentPage, isSearching])

  return (
    <>
      <div className='wooarchive-settings__dashboard'>
        <div className='header arcm-flex-wrap arcm-flex arcm-items-center arcm-justify-between arcm-gap-2 arcm-mb-8'>
          <h4 className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold'>
            Archived Orders
          </h4>

          <div className='arcm-inline-flex arcm-flex-wrap arcm-items-center arcm-gap-x-4 !arcm-gap-y-2.5 sm:arcm-gap-8 arcm-ml-auto'>
            <Link
              to='/'
              className={`arcm-text-xs sm:arcm-text-sm arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9] arcm-text-gray-800`}
            >
              <span className='icon'>{arcmIcons.dashboard}</span>
              Dashboard
            </Link>
            <Link
              to='/?value=archive_settings'
              className='arcm-text-xs sm:arcm-text-sm arcm-text-gray-800 arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9]'
            >
              <span className='icon'>{arcmIcons.settings}</span>
              Archive settings
            </Link>
            <Link
              to='/archived-order'
              className={`arcm-text-xs sm:arcm-text-sm arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9] ${
                isActive('/archived-order')
                  ? 'arcm-text-[#3858e9] active'
                  : 'arcm-text-gray-800'
              } `}
            >
              <span className='icon'>{arcmIcons.archiveOrders}</span>
              Archived Orders
            </Link>
            <Link
              to='/?value=export_orders'
              className={`arcm-text-xs sm:arcm-text-sm arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9] ${
                activeView === 'export_orders'
                  ? 'arcm-text-[#3858e9] active'
                  : 'arcm-text-gray-800'
              }`}
            >
              <span className='icon'>{arcmIcons.exportOrders}</span>
              Export Data
            </Link>
            <Link
              to='/logs'
              className={`arcm-text-xs sm:arcm-text-sm arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1 arcm-group arcm-transition-all hover:arcm-text-[#3858e9] arcm-text-gray-800`}
              type='button'
            >
              <span className='icon'>{arcmIcons.logs}</span>
              Log
            </Link>
            {!isPro && (
              <button
                onClick={redirectProPage}
                className='arcm-btn-bounce arcm-text-xs sm:arcm-text-sm arcm-text-[#A34AE8] arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1'
              >
                <span className='icon arcm-inline-block'>
                  {arcmIcons.upgrade}
                </span>
                Upgrade Now
              </button>
            )}
          </div>
        </div>

        <div className='arcm-flex arcm-gap-4 arcm-flex-wrap arcm-items-center arcm-justify-between arcm-mb-4'>
          <div className='arcm-inline-flex arcm-flex-wrap arcm-gap-2'>
            <Select
              defaultValue={bulkAction}
              onChange={value => setBulkAction(value)}
              className='arcm-select arcm-flex-grow arcm-text-gray-400 arcm-text-sm arcm-font-normal arcm-w-[200px]'
            >
              <Option value=''>Bulk actions</Option>
              <Option value='unarchive'>Unarchive orders</Option>
            </Select>

            <button
              onClick={handleBulkAction}
              className='arcm-text-white arcm-text-xs arcm-font-medium arcm-px-4 arcm-py-[11px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
            >
              Apply
            </button>
          </div>

          <div className='arcm-inline-flex arcm-flex-wrap arcm-gap-2 arcm-ml-auto'>
            <input
              type='text'
              class='!arcm-p-4 !arcm-bg-white arcm-h-[38px] !arcm-rounded-lg !arcm-border !arcm-border-gray-400 !arcm-text-gray-400 !arcm-text-sm !arcm-font-normal !arcm-shadow-none placeholder:!arcm-text-gray-400 !arcm-w-[256px] focus:!arcm-border-[#3858e9]'
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              placeholder='Search orders...'
            />
            <Select
              value={searchStatus}
              onChange={value => setSearchStatus(value)}
              className='arcm-select arcm-flex-grow arcm-text-gray-400 arcm-text-sm arcm-font-normal arcm-w-[130px]'
            >
              <Option value=''>All Status</Option>
              <Option value='pending'>Pending</Option>
              <Option value='processing'>Processing</Option>
              <Option value='completed'>Completed</Option>
              <Option value='cancelled'>Cancelled</Option>
            </Select>
            <button
              onClick={handleSearch}
              className='arcm-text-white arcm-text-xs arcm-font-medium arcm-px-4 arcm-py-[11px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
            >
              Search Orders
            </button>
            {isSearching && (
              <button
                onClick={clearSearch}
                className='arcm-text-gray-600 arcm-text-xs arcm-font-medium arcm-px-4 arcm-py-[11px] arcm-bg-gray-100 arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-gray-200'
              >
                Clear Search
              </button>
            )}
          </div>
        </div>

        {/* Table */}
        <div className='arcm-overflow-hidden arcm-mb-6'>
          <table className='arcm-min-w-full arcm-mt-0'>
            <thead>
              <tr>
                <th className='arcm-border-0 arcm-w-12 arcm-px-6 arcm-py-5 arcm-bg-blue-100 first:arcm-rounded-tl-lg'>
                  <input
                    type='checkbox'
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className='arcm-rounded arcm-border-gray-400 !arcm-bg-transparent'
                  />
                </th>
                <th className='arcm-bg-blue-100 arcm-border-0 arcm-px-6 arcm-py-5 arcm-text-left arcm-text-sm arcm-font-semibold arcm-text-gray-900'>
                  Order
                </th>
                <th className='arcm-bg-blue-100 arcm-border-0 arcm-px-6 arcm-py-5 arcm-text-left arcm-text-sm arcm-font-semibold arcm-text-gray-900'>
                  Date
                </th>
                <th className='arcm-bg-blue-100 arcm-border-0 arcm-px-6 arcm-py-5 arcm-text-left arcm-text-sm arcm-font-semibold arcm-text-gray-900'>
                  Order Status
                </th>
                <th className='arcm-bg-blue-100 arcm-border-0 arcm-px-6 arcm-py-5 arcm-text-sm arcm-font-semibold arcm-text-gray-900 arcm-text-right last:arcm-rounded-tr-lg'>
                  Archive Action
                </th>
              </tr>
            </thead>
            <tbody className=''>
              {tableLoading ? (
                <tr>
                  <td colSpan={5} className='arcm-h-[240px]'>
                    <span className='arcm-table-loader arcm-w-full arcm-h-full arcm-flex arcm-items-center arcm-justify-center'>
                      {arcmIcons.SpinningAnimation}
                    </span>
                  </td>
                </tr>
              ) : orders.length > 0 ? (
                orders.map((order, index) => {
                  // Parse the order_data string to get the status
                  const orderData = JSON.parse(order.order_data)
                  return (
                    <tr
                      key={order.id}
                      className='odd:arcm-bg-white even:arcm-bg-transparent'
                    >
                      <td
                        className={`arcm-border-0 arcm-px-6 arcm-py-4 ${
                          index === orders.length - 1
                            ? 'arcm-rounded-bl-lg'
                            : ''
                        }`}
                      >
                        <input
                          type='checkbox'
                          checked={order.is_selected}
                          onChange={() => handleSelectOrder(order.id)}
                          className='arcm-rounded arcm-border-gray-400 !arcm-bg-transparent'
                        />
                      </td>
                      <td className='arcm-border-0 arcm-px-6 arcm-py-4 arcm-text-sm arcm-text-gray-900'>
                        #{orderData.id}
                      </td>
                      <td className='arcm-border-0 arcm-px-6 arcm-py-4 arcm-text-sm arcm-text-gray-900'>
                        {new Date(
                          orderData.date_created.date
                        ).toLocaleDateString()}
                      </td>
                      <td className='arcm-border-0 arcm-px-6 arcm-py-4 arcm-text-sm arcm-text-gray-900'>
                        {orderData.status.charAt(0).toUpperCase() +
                          orderData.status.slice(1)}
                      </td>
                      <td
                        className={`arcm-border-0 arcm-px-6 arcm-py-4 arcm-text-sm arcm-text-right ${
                          index === orders.length - 1
                            ? 'arcm-rounded-br-lg'
                            : ''
                        }`}
                      >
                        <button
                          onClick={() => singelOrderUnarchive(order.id)}
                          className='arcm-px-4 arcm-py-2 arcm-rounded-full arcm-border arcm-border-blue-600 arcm-text-blue-600 arcm-text-sm arcm-font-semibold arcm-transition-all hover:arcm-bg-blue-600 hover:arcm-text-white'
                        >
                          Unarchive
                        </button>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={5} className='arcm-h-[240px]'>
                    <span className='arcm-table-loader arcm-text-sm arcm-font-bold arcm-w-full arcm-h-full arcm-flex arcm-items-center arcm-justify-center'>
                      'No archived data found'
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
      {/* <div className='table-container'>
            <div className='bulk-action-container arcm-gap-4'>
                <Select defaultValue={bulkAction} onChange={value => setBulkAction(value)} className=" arcm-flex-grow arcm-text-gray-400 arcm-text-sm arcm-font-normal arcm-max-w-[200px]">
                    <Option value=''>Bulk actions</Option>
                    <Option value='unarchive'>Unarchive orders</Option>
                </Select>

                <button onClick={handleBulkAction} class="arcm-text-white arcm-text-xs arcm-font-medium arcm-px-4 arcm-py-[11px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700">
                    <span>Apply</span>
                </button>
            </div>

            <table>
                <thead>
                    <tr>
                        <th>
                            <input
                            type='checkbox'
                            checked={selectAll}
                            onChange={handleSelectAll}
                            />
                        </th>
                        <th>Order</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Total</th>
                        <th>Archive Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableLoading ? (
                        <tr>
                            <td colSpan={12} className='arcm-h-[240px]'>
                            <span className='arcm-table-loader arcm-w-full arcm-h-full arcm-flex arcm-items-center arcm-justify-center'>
                                {arcmIcons.SpinningAnimation}
                            </span>
                            </td>
                        </tr>
                    ) : orders.length > 0 ? (
                        orders.map(order => (
                        <tr key={order.host_id} id={order.host_id}>
                        <td>
                            <input
                            type='checkbox'
                            checked={order.is_selected}
                            onChange={() => handleSelectOrder(order.host_id)}
                            />
                        </td>
                        <td>#{order.host_id}</td>
                        <td>{order.date_created_gmt}</td>
                        <td>{order.status_name}</td>
                        <td>{order.total_amount}</td>
                        <td>
                            <button
                            onClick={() => singelOrderUnarchive(order.host_id)}
                            className='unarchive-button'
                            >
                            Unarchive
                            </button>
                        </td>
                        </tr>
                    ))
                    ) : (
                        <tr>
                            <td colSpan={12} className='arcm-h-[240px]'>
                                <span className='arcm-table-loader arcm-text-sm arcm-font-bold arcm-w-full arcm-h-full arcm-flex arcm-items-center arcm-justify-center'>
                                    {isDbConnected ? 'No archived data found' : "RDS is not configured. Please configure RDS database"}
                                </span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className='pagination'>
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span>
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div> */}
      <Modal
        openModal={isOpenUnarchiveModal}
        toggleModal={handleUnarchiveModal}
        outerClick={false}
      >
        {{
          header: !modalLoading ? <div></div> : '',
          body: modalLoading ? (
            <div className='arcm-text-center arcm-mb-6'>
              <div className='icon arcm-inline-flex'>
                {arcmIcons.SpinningAnimation}
              </div>
              <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                {modalTile}
              </h5>
              <p className='arcm-text-center arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-6'>
                {modaDesc}
              </p>
            </div>
          ) : (
            <div className='arcm-text-center arcm-my-6'>
              <div className='icon arcm-inline-flex arcm-mb-6'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='60'
                  height='60'
                  viewBox='0 0 60 60'
                  fill='none'
                >
                  <path
                    d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                    fill='#27D935'
                  />
                  <path
                    d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                    fill='#27D935'
                  />
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M14.5801 31.414L24.5801 41.414C25.3601 42.196 26.6281 42.196 27.4081 41.414L45.4081 23.414C46.1881 22.634 46.1881 21.366 45.4081 20.586C44.6281 19.806 43.3601 19.806 42.5801 20.586L25.9941 37.172L17.4081 28.586C16.6281 27.806 15.3601 27.806 14.5801 28.586C13.8001 29.366 13.8001 30.634 14.5801 31.414Z'
                    fill='white'
                  />
                </svg>
              </div>
              <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                {modalTile}
              </h5>
              <button
                onClick={handleUnarchiveModal}
                className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-min-w-[120px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
              >
                <span>Ok</span>
              </button>
            </div>
          )
        }}
      </Modal>
    </>
  )
}

export default ArchivedOrder
